<template>
  <v-toolbar>
    <img :src="logo" alt="" width="50">
    <v-toolbar-title>
        {{titulo}}
        </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
export default {
    props: ['titulo', 'logo']
}
</script>




// WEBPACK FOOTER //
// src/components/user/mensagens/layout/MenuSuperior.vue